import { useState, useEffect, useRef, useMemo } from 'react';
import filterNonRootItems from 'utils/filter-non-root-items';

const useMenu = (items, styles) => {
  const dropdownArrowRef = useRef();
  const [activeLabel, setActiveLabel] = useState('');

  // Graphql does not allow to filter by null values so has to do it manually
  const menuItems = useMemo(() => filterNonRootItems(items), []);

  const handleNavBlur = () => {
    dropdownArrowRef.current.hidden = true;
    setActiveLabel('');
  };

  const handleLabelSelected = ({ currentTarget }) => {
    const { label } = currentTarget.dataset;
    const dropdownArrowPosition = currentTarget.offsetLeft + currentTarget.offsetWidth / 2;

    if (label) {
      dropdownArrowRef.current.hidden = false;
      dropdownArrowRef.current.style = `left: ${dropdownArrowPosition}px`;
    } else {
      dropdownArrowRef.current.hidden = true;
    }

    setActiveLabel(label);
  };

  const setDropdownPosition = () => {
    const mediaQuery = window.matchMedia('(min-width: 1023.98px)');

    if (mediaQuery) {
      const items = document.querySelectorAll(`.${styles.item}`);
      const dropdownMenus = document.querySelectorAll(`.${styles.dropdown}`);

      items.forEach((item) => {
        const itemLabel = item.dataset.label;
        const itemPosition = item.offsetLeft + item.offsetWidth / 2;

        if (itemLabel) {
          dropdownMenus.forEach((dropdown) => {
            const dropdownLabel = dropdown.dataset.label;
            const hasSubMenuSections =
              dropdown.classList.contains(`${styles.dropdownSections}`) &&
              dropdown.dataset.columns > 1;

            if (itemLabel === dropdownLabel && !hasSubMenuSections) {
              // eslint-disable-next-line no-param-reassign
              dropdown.style = `left: ${itemPosition}px`;
            }
          });
        }
      });
    }
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setDropdownPosition();
      window.addEventListener('resize', setDropdownPosition);

      return () => {
        window.removeEventListener('resize', setDropdownPosition);
      };
    }
  }, []);

  return {
    menuItems,
    dropdownArrowRef,
    activeLabel,
    handleNavBlur,
    handleLabelSelected,
  };
};

export default useMenu;
